import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { useLazyListUserDeliveryPricesForReportsQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportUserCODReport = ({ responsibleUser, chargeType }) => {
  const [fetchCODUserReport, { isLoading, isFetching }] =
    useLazyListUserDeliveryPricesForReportsQuery();

  const handleDownload = async () => {
    try {
      const queryParams = {
        responsibleUser: responsibleUser === "all" ? undefined : responsibleUser,
        chargeType: chargeType || "All",
        limit: Number.MAX_SAFE_INTEGER, // Fetch all data for download
        page: 1,
      };
      console.log("Downloading COD report with params:", queryParams);
      const responseData = await fetchCODUserReport(queryParams)
        .unwrap()
        .then((data) => {
          console.log("Download API call successful");
          return data;
        })
        .catch((err) => {
          console.error("Download API call failed:", err);
          throw err;
        });

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data available for the selected filters.");
        return;
      }

  const formattedData = responseData.data.map((row, index) => ({
  SN: index + 1,
  Name: row.responsibleUserName || "N/A",
  Pending: row?.totalNotPaid ? Number(Math.abs(row.totalNotPaid).toFixed(2)) : 0,
  Paid: row?.totalPaid ? Number(Math.abs(row.totalPaid).toFixed(2)) : 0,
  Collected: row?.totalCollected ? Number(Math.abs(row.totalCollected).toFixed(2)) : 0,
  Total: row?.total ? Number(Math.abs(row.total).toFixed(2)) : 0,
    }));


      exportExcelFile({
        sheetData: formattedData,
        fileName: `COD_User_Report_${chargeType}_${responsibleUser === "all" ? "AllUsers" : responsibleUser}`,
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error("Error fetching COD user report data: " + error.message);
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportUserCODReport;